<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>ご契約締結書類一覧のご確認</HeadingOne>
    <p>ご契約締結に関する書面を確認することができます。</p>

    <section>
      <HeadingTwo>ご契約内容の事前のご案内</HeadingTwo>
      <ListGroup class="-link _mb-sm-30 _mb-md-60">
        <template v-if="beforeReports">
          <ListItem
            v-for="(report, index) in beforeReports"
            :key="'report' + index"
            href="#"
            class="-link"
            @click.prevent="showPdf(report)"
          >
            <ElementBox class="-center">
              <HeadingIcon class="_mb-0">
                <p class="heading _mb-0">
                  {{ ymdDateFormat(report.create_date, "/") }}
                </p>
                <IconBox
                  src="pdf"
                  class="icon -sm _ml-sm-5 _ml-md-10"
                ></IconBox>
              </HeadingIcon>
            </ElementBox>
          </ListItem>
        </template>
      </ListGroup>

      <HeadingTwo>ご契約内容のご案内</HeadingTwo>
      <ListGroup class="-link _mb-sm-30 _mb-md-60">
        <template v-if="completionReports">
          <ListItem
            v-for="(report, index) in completionReports"
            :key="'report' + index"
            href="#"
            class="-link"
            @click.prevent="showPdf(report)"
          >
            <ElementBox class="-center">
              <HeadingIcon class="_mb-0">
                <p class="heading _mb-0">
                  {{ ymdDateFormat(report.create_date, "/") }}
                </p>
                <IconBox
                  src="pdf"
                  class="icon -sm _ml-sm-5 _ml-md-10"
                ></IconBox>
              </HeadingIcon>
            </ElementBox>
          </ListItem>
        </template>
      </ListGroup>
      <BtngroupSingle class="_mb-md-120 _mb-sm-60">
        <BtnMain class="-main" router-name="mb001">
          会員さま専用サイトトップへ
        </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import {
  contractPdfListLambdaInvoke,
  getUserSessionLambdaInvoke,
  apiGetPdfFile,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { ymdDateFormat } from "@/utils/Filter";
import { goToErrorPage } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import ElementBox from "@/components/elements/ElementBox";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb020",
  components: {
    BtnMain,
    BtngroupSingle,
    IconBox,
    HeadingIcon,
    ElementBox,
    ListItem,
    ListGroup,
    HeadingTwo,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご契約締結書類一覧のご確認｜ご契約内容のご確認",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,ご契約内容",
    });

    return {
      ymdDateFormat,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご契約締結書類一覧のご確認",
          active: true,
        },
      ],
      beforeReports: [],
      completionReports: [],
      pdfList: [],
      userSessionData: {
        user_session: "",
        state: "",
      },
    };
  },
  mounted() {
    contractPdfListLambdaInvoke()
      .then((res) => {
        let resBody = JSON.parse(res.body);
        let pdfList = resBody.pdf_list;
        for (let pdf of pdfList) {
          if (Object.prototype.hasOwnProperty.call(pdf, "reports")) {
            for (let report of pdf.reports) {
              if (report.report_type === "01") {
                this.beforeReports.push(report);
              }
              if (report.report_type === "02" || report.report_type === "03") {
                this.completionReports.push(report);
              }
            }
          }
        }
        this.sortBeforeReports();
        this.sortCompletionReports();
      })
      .catch((error) => {
        goToErrorPage(error);
      });
    getUserSessionLambdaInvoke()
      .then((res) => {
        for (let key in res) {
          if (Object.prototype.hasOwnProperty.call(this.userSessionData, key)) {
            this.userSessionData[key] = res[key];
          }
        }
      })
      .catch((error) => {
        goToErrorPage(error);
      });
  },
  methods: {
    showPdf(report) {
      const userSession = this.userSessionData["user_session"];
      const reportId = report.report_id;
      const reportType = report.report_type;
      const state = this.userSessionData["state"];

      apiGetPdfFile({
        user_session: userSession,
        report_id: reportId,
        report_type: reportType,
        state: state,
      })
        .then(() => {
          window.open(
            `${process.env.VUE_APP_GET_PDF_FILE}?user_session=${userSession}&report_id=${reportId}&report_type=${reportType}&state=${state}`,
            "_blank"
          );
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    },
    sortBeforeReports() {
      this.beforeReports.sort(function (a, b) {
        if (a.create_date < b.create_date) return 1;
        if (a.create_date > b.create_date) return -1;
        return 0;
      });
    },
    sortCompletionReports() {
      this.completionReports.sort(function (a, b) {
        if (a.create_date < b.create_date) return 1;
        if (a.create_date > b.create_date) return -1;
        return 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.heading-icon {
  text-align: left !important;
  justify-content: left !important;
  .heading {
    font-size: 16px !important;
  }
}
</style>
